var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.isShowBanner,
          expression: "isShowBanner"
        }
      ],
      attrs: { id: "sticky-banner" }
    },
    [
      _c("div", {
        domProps: {
          innerHTML: _vm._s(_vm.replaceHTMLSellerInfo(_vm.bannerContent))
        }
      }),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "banner-close",
          on: {
            click: function($event) {
              _vm.closeBanner()
            }
          }
        },
        [
          _c("i", {
            staticClass: "fa fa-times-circle",
            attrs: { "aria-hidden": "true" }
          })
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-413d2880", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-413d2880","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/productsNew/Banner.vue
// module id = null
// module chunks = 